import React from 'react'
import { Service } from '@/payload-types'
import { RichText } from '@payloadcms/richtext-lexical/react'
import { Blocks } from '@/components'

interface ServiceDetailProps {
  page: Service
}

function ServiceDetail({ page }: Readonly<ServiceDetailProps>) {
  return (
    <>
      <section className="max-w-4xl mx-auto p-4">
        {page.content && <RichText data={page.content} className="prose prose-neutral" />}
      </section>
      {page.blocks && <Blocks blocks={page.blocks} />}
    </>
  )
}

export { ServiceDetail }
